<template>
  <div class="payment-form-wrapper">
    <div class="container">
      <transition
        name="fade"
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
      >
        <div key="1" v-if="loader" class="white-row loader-route">
          <div class="lds-sub-ripple">
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-else key="2" class="white-row">
          <div class="form-wrappers">
            <div class="jumbotron text-center">
              <h1 class="display-3">Thank You!</h1>
              <p class="lead">
                <strong
                  >Your Payment has been received, You can view your invoice by
                  logging in to PNC WORKBENCH and it has been sent on your email
                  as well. Please check your email for further
                  instructions.</strong
                >
              </p>
              <hr />
              <p class="lead">
                <a
                  class="btn btn-primary btn-sm"
                  href="https://pncworkbench.com/"
                  role="button"
                  >Continue to Login</a
                >
              </p>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "thank-you-page",
  components: {},
  data() {
    return {
      event: null,
      loader: true
    };
  },
  mounted() {
    this.loader = false;
  },
  computed: {},
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);
      element.style.height = this.prevHeight;
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    }
  }
};
</script>

<style lang="scss" scoped>
.lead {
  font-size: 1.25rem;
  font-weight: 300;
  margin-bottom: 0;
  padding: 10px 30px;
}
.white-row {
  margin-top: 30px;
}
.jumbotron {
  background-color: transparent;
}
a.btn.btn-primary.btn-sm {
  padding: 8px 45px;
  margin: 0;
  font-size: 17px;
}

@media screen and (max-width: 1199px) {
}
@media screen and (max-width: 767px) {
}
@media screen and (max-width: 599px) {
  .display-3 {
    font-size: 50px;
    font-weight: 300;
    line-height: 1.2;
  }
  .lead[data-v-cdc04276] {
    font-size: 1.25rem;
    padding: 10px 0;
  }
  body .white-row {
    padding: 20px 4px 24px;
  }
  .jumbotron.text-center {
    margin: 0;
    padding: 10px 10px;
  }
}
@media screen and (max-width: 479px) {
}

@media screen and (min-width: 1200px) {
}
</style>
